var render = function render(){var _vm=this,_c=_vm._self._c;return _c('state-container',{attrs:{"status":"failed","is-collapsible":""}},[_c('bold-text',{attrs:{"message":_vm.$options.message}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }